function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  'use strict';

  angular.module('wsLrs.services').factory('ReportLinks', ['Utils', 'ChartUtils', function (Utils, ChartUtils) {
    var module = {
      hasLinkConfig: function hasLinkConfig(config, measure, index) {
        return config.reportLinks && config.reportLinks["m" + index] && !measure.showModalLink;
      },
      redirectOrReturnLink: function redirectOrReturnLink(shouldRedirect, url, valueDisplay) {
        if (shouldRedirect) {
          // redirect the page to the linked report -- not instantaneous, code called after this block can still be executed
          var _window$location = window.location,
            origin = _window$location.origin,
            pathname = _window$location.pathname;
          window.location = origin + pathname + url;
        }

        // Update value display to a link & return
        return "<a href=\"".concat(url, "\">").concat(valueDisplay, "</a>");
      },
      isFilterTemplateVar: function isFilterTemplateVar(value) {
        if (typeof value === "string") {
          var firstPathPart = value.slice(0, value.indexOf("."));
          return firstPathPart === "$reportFilter" || firstPathPart === "$measureFilter";
        }
        return false;
      },
      resolveFilterTemplate: function resolveFilterTemplate(filterTemplate, filterRefs) {
        var resolvedFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var self = this;
        _.each(Object.entries(filterTemplate), function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          if (self.isFilterTemplateVar(value)) {
            var templateVarContext = filterRefs[value.slice(0, value.indexOf("."))];
            var templateVarPath = value.slice(value.indexOf(".") + 1);
            resolvedFilter[key] = Utils.getIn(templateVarContext, templateVarPath);
          } else if (Utils.isArray(value)) {
            value = value.map(function (item) {
              return self.resolveFilterTemplate({
                resolve: item
              }, filterRefs).resolve;
            });
            /* jshint ignore:start */
            resolvedFilter[key] = _toConsumableArray(new Set(value)).filter(function (i) {
              return !!i;
            });
            /* jshint ignore:end */
          } else if (_typeof(value) === "object" && !Utils.isArray(value)) {
            resolvedFilter[key] = self.resolveFilterTemplate(value, filterRefs, resolvedFilter[key]);
          } else {
            resolvedFilter[key] = value;
          }
        });
        return resolvedFilter;
      },
      applyLinkConfig: function applyLinkConfig(config, measure) {
        var valueDisplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var measureIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var dimensionValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var shouldRedirect = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
        var self = this;
        var linkConfig = config.reportLinks["m" + measureIndex];
        if (linkConfig.url) {
          var url = linkConfig.url;
          if (linkConfig.filter || linkConfig.measureAsFilter || linkConfig.dimensionAsFilter || linkConfig.useParentFilter) {
            var filter = {};
            if (linkConfig.filter) {
              filter = linkConfig.filter;
            } else if (linkConfig.measureAsFilter || linkConfig.dimensionAsFilter) {
              var filterVar, filterType;
              if (linkConfig.dimensionAsFilter) {
                filterVar = "$dimension";
                filterType = linkConfig.dimensionAsFilter;
              } else if (linkConfig.measureAsFilter) {
                filterVar = "$measure";
                filterType = linkConfig.measureAsFilter;
              }
              if (filterType === "activity") {
                filter = {
                  activityIds: {
                    ids: [filterVar]
                  }
                };
              } else if (filterType === "person") {
                filter = {
                  personIds: [filterVar]
                };
              } else if (filterType === "group") {
                filter = {
                  groupIds: [filterVar]
                };
              } else if (filterType === "contextActivity") {
                filter = {
                  contextActivityIds: {
                    ids: [filterVar]
                  }
                };
              }
            }
            var resolvedFilter = self.resolveFilterTemplate(filter, {
              "$reportFilter": config.filter,
              "$measureFilter": measure.filter
            });
            /* jshint ignore:start */
            resolvedFilter = linkConfig.useParentFilter ? _objectSpread(_objectSpread({}, config.filter), resolvedFilter) : resolvedFilter;
            /* jshint ignore:end */
            var removeDimensionVarQuotes = typeof dimensionValue === "number";
            var removeMeasureVarQuotes = typeof measure.value === "number";
            var filterParam = JSON.stringify(resolvedFilter).replace(removeDimensionVarQuotes ? '"$dimension"' : '$dimension', dimensionValue).replace(removeMeasureVarQuotes ? '"$measure"' : "$measure", measure.value);
            url = Utils.appendParams(url, {
              "filter": filterParam,
              "collapseQuickFilters": true
            });
          }
          valueDisplay = this.redirectOrReturnLink(shouldRedirect, url, valueDisplay);
        }
        return valueDisplay;
      }
    };
    module.BarCharts = {
      LinkParameters: {
        // provides a mechanism for establishing and maintaining parameters needed for linked reports where
        // the source of the data is being processed/manipulated, and we need pieces from the 'before' and 'after'
        initialize: function initialize(labeledMeasure, index, dimensionValue) {
          return {
            labeledMeasure: Object.assign({}, labeledMeasure),
            measureIndex: index,
            dimensionValue: dimensionValue
          };
        },
        finalize: function finalize(params, displayValue, label) {
          return Object.assign({}, params, {
            displayValue: displayValue,
            label: label
          });
        }
      },
      tooltipContent: function (config, measure, displayValue, index) {
        // provides drill-down indicator in chart tooltips when a report link is configured on a given measure
        if (module.hasLinkConfig(config, measure, index)) {
          return ChartUtils.tooltipContent(measure.name, "".concat(displayValue, " (Click to drill down)"));
        } else {
          return ChartUtils.tooltipContent(measure.name, displayValue);
        }
      }.bind(module)
    };
    var makeEventHandler = Utils.makeEventHandler;
    var makeEventObserver = function makeEventObserver(path, events) {
      return Object.freeze({
        path: path,
        events: events
      });
    };
    var addObserver = function addObserver(ob, event, handleEvent, _ref3) {
      var path = _ref3.path,
        params = _ref3.params;
      return Utils.setIn(ob, "".concat(path, ".events.").concat(event), function (e) {
        handleEvent(event, this, Object.assign({}, params, {
          domEvent: e
        }));
      }, {
        force: true
      });
    };
    var _Utils$createEventReg = Utils.createEventRegister(module, addObserver),
      registerEventHandlers = _Utils$createEventReg.registerEventHandlers,
      registerObservers = _Utils$createEventReg.registerObservers;
    registerEventHandlers(makeEventHandler('click', function (module) {
      return function (scope, _ref4) {
        var config = _ref4.config,
          domEvent = _ref4.domEvent;
        var linkParams = domEvent.point.linkParams;
        var measure = config.measures[linkParams.measureIndex];
        if (module.hasLinkConfig(config, measure, linkParams.measureIndex)) {
          module.applyLinkConfig(config, measure.value ? measure : Object.assign({}, measure, linkParams.labeledMeasure), domEvent.point.name, linkParams.measureIndex, linkParams.dimensionValue, true);
        }
      };
    }), makeEventHandler('mouseOver', function (module) {
      return function (scope, _ref5) {
        var config = _ref5.config;
        // changes the cursor to a pointer when a report link is configured
        var linkParams = scope.linkParams;
        if (!linkParams || linkParams === {}) {
          return;
        }
        if (module.hasLinkConfig(config, config.measures[linkParams.measureIndex], linkParams.measureIndex)) {
          scope.series.group.element.style.cursor = 'pointer';
        }
      };
    }), makeEventHandler('mouseOut', function () {
      return function (scope) {
        // revert to default cursor
        scope.series.group.element.style.cursor = 'default';
      };
    }));
    module.BarCharts.makeEventObserver = makeEventObserver;
    module.BarCharts.registerObservers = registerObservers;
    return module;
  }]);
})();
